import { WorkspaceRoleType } from '@/pages/BuildCache/components/BuildCacheActivation/types/BuildCacheActivation';

type WorkspaceRoleProps = {
  canViewWorkspace: boolean;
  canViewBillingData: boolean;
};

export const getWorkspaceRole = ({ canViewWorkspace, canViewBillingData }: WorkspaceRoleProps): WorkspaceRoleType => {
  if (canViewBillingData) return WorkspaceRoleType.owner;
  if (canViewWorkspace) return WorkspaceRoleType.workspaceViewer;
  return WorkspaceRoleType.workspaceContributor;
};
